import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from "../../../../../../../../core/shared/widget/widget-data";
import {WidgetFactory} from "../../../../../../../../core/shared/widget/service/widget.factory";
import {FilterCriteria} from "../../../../../../../../core/shared/filter/api/filter.criteria";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../../core/shared/helper/widget-function-call-back-create";
import {ObjectIdentifier} from "../../../../../../../../core/shared/basic/object-identifier";
import {ObjectIdentifierData} from "../../../../../../../../core/shared/basic/object-identifier-data";
import {
    MvsObjectNavigationService
} from "../../../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {
    MvsObjectNavigationEntry
} from "../../../../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsObjectNavigationActionEnum
} from "../../../../../../../../core/shared/navigation/mvs-object-navigation-action-enum";


@Component({
    selector: 'ei-structure-field-values-component',
    templateUrl: 'ei-structure-field-values.component.html',
    standalone: false
})
export class EiStructureFieldValuesComponent implements OnInit, OnChanges {

    @Input() structureFieldId: number;
    @Input() importTypeId: number;

    initialized: boolean;
    valuesWidget: WidgetData;

    constructor(protected navigationService: MvsObjectNavigationService) {
    }

    ngOnInit() {
        this.initComponent();
        this.initialized = true;
    }

    initComponent() {
        if (!this.structureFieldId) {
            return;
        }

        this.valuesWidget = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
            'ei.structureField.values.widget',
            'Feldwerte',
            'ei.EiStructureFieldValue',
            [FilterCriteria.create('e.structureFieldId', FilterCriteria.cOperatorEqual, this.structureFieldId)],
            []
        );

        // FK defaulting on create (CONFIG-012)
        const fields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'structureFieldDtoId', fieldValue: this.structureFieldId},
        ];
        if (this.importTypeId) {
            fields.push({fieldName: 'importTypeDtoId', fieldValue: this.importTypeId});
        }
        this.valuesWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }

    onItemSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        if (!event?.objectId) {
            return;
        }
        const entry = MvsObjectNavigationEntry.createNavigationEntry(
            'ei.EiStructureFieldValue',
            event.objectId,
            'object', '', '', '',
            MvsObjectNavigationActionEnum.edit
        );
        this.navigationService.navigateTo(entry, 'main');
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
        this.initComponent();
    }

}
